import type { AxiosError } from 'axios';
import { ethers } from 'ethers';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { ERC20_ABI } from 'src/constants/abi';
import { DYDX_TOKEN_ADDRESS, WETH_DYDX_TOKEN_ADDRESS } from 'src/constants/tokens';

import { useCurrentWallet } from './useCurrentWallet';
import useProvider from './useProivder';

type FetchParams = {
  address: string;
};

type UseAllowanceSWRProps = {
  accAddress?: string;
};

export function useAllowanceSWR(props?: UseAllowanceSWRProps, config?: SWRConfiguration) {
  const { accAddress } = props || {};

  const { provider } = useProvider();
  const { currentWallet } = useCurrentWallet();

  const fetcher = async (params: FetchParams) => {
    const erc20Contract = new ethers.Contract(DYDX_TOKEN_ADDRESS, ERC20_ABI, provider);

    const wethDYDXAllowance = (await erc20Contract.allowance(params.address, WETH_DYDX_TOKEN_ADDRESS)) as bigint;

    return wethDYDXAllowance.toString();
  };

  const { data, isValidating, error, mutate } = useSWR<string | null, AxiosError>({ id: 'allowance', address: accAddress }, fetcher, {
    dedupingInterval: 9000,
    refreshInterval: 10000,
    errorRetryCount: 0,
    isPaused: () => !accAddress || !provider || !currentWallet.name,
    ...config,
  });

  return { data, isValidating, error, mutate };
}
